function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M 5.5 40.5 L 42.5 40.5 C 44.433594 40.5 46 38.933594 46 37 L 46 11 C 46 9.066406 44.433594 7.5 42.5 7.5 L 5.5 7.5 C 3.566406 7.5 2 9.066406 2 11 L 2 37 C 2 38.933594 3.566406 40.5 5.5 40.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9D9D9"
    },
    d: "M 26 40.5 L 42.5 40.5 C 44.433594 40.5 46 38.933594 46 37 L 46 11 C 46 9.066406 44.433594 7.5 42.5 7.5 L 5.5 7.5 C 3.566406 7.5 2 9.066406 2 11 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEEEEE"
    },
    d: "M 6.746094 40.5 L 42.5 40.5 C 44.433594 40.5 46 38.933594 46 37 L 46 11.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M 25.746094 40.5 L 42.5 40.5 C 44.433594 40.5 46 38.933594 46 37 L 46 11.5 L 18.769531 31.617188 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CA3737"
    },
    d: "M 42.5 9.5 L 5.5 9.5 C 3.566406 9.5 2 9.066406 2 11 L 2 37 C 2 38.933594 3.566406 40.5 5.5 40.5 L 7 40.5 L 7 12 L 41 12 L 41 40.5 L 42.5 40.5 C 44.433594 40.5 46 38.933594 46 37 L 46 11 C 46 9.066406 44.433594 9.5 42.5 9.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M 42.5 7.5 L 5.5 7.5 C 3.566406 7.5 2 9.035156 2 11 C 2 12.207031 3.519531 13.257813 3.519531 13.257813 L 24 27.757813 L 44.480469 13.257813 C 44.480469 13.257813 46 12.207031 46 11 C 46 9.035156 44.433594 7.5 42.5 7.5 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E84F4B"
    },
    d: "M 43.246094 7.582031 L 24 21 L 4.753906 7.582031 C 3.179688 7.917969 2 9.296875 2 11 C 2 12.207031 3.519531 13.257813 3.519531 13.257813 L 24 27.757813 L 44.480469 13.257813 C 44.480469 13.257813 46 12.207031 46 11 C 46 9.296875 44.820313 7.917969 43.246094 7.582031 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIcon);
export default __webpack_public_path__ + "static/media/gmail-icon.40814cd8bb6eddea2d9aa88347d20ba1.svg";
export { ForwardRef as ReactComponent };